//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import CHART from '../library/chart'
import WILAYAH from  '../library/getWilayah'
import UMUM from  '../library/umum.js'

export default {
  data() {
    return {
      alert: false,
      simpan1: false,
      model :'',
      inputSelect : [
        {id : '1', nama : 'kiken', alamat : 'beringin'},
        {id : '2',nama : 'Alung', alamat : 'Anawai'},
      ],
      date : '',
      listCabup : [],

      bar  : {
        jml_dpt : 0,
        jml_relawan : 0,
        jml_dukungan : 0,
      },
      cek_load_data : true,

      form : {
        tahun : '',
        des_kel : '',
        kecamatan : '',
        lev_kec : true,
      },

      disable_kec : false,
      disable_des : false,
    }
  },
  methods: {


  


    Potensi_Wilayah : async function(){
      var body = this.form
      var dataArray = await CHART.postData('PotensiWilayah', body);
      // console.log(dataArray)
      CHART.BarChart('Potensi_Wilayah', 'Potensi Wilayah', 'Data Potensi Wilayah', dataArray.uraian, dataArray.jumlah)
    },

    JenisUsaha : async function(){
      var body = this.form
      var dataArray = await CHART.postData('JenisUsaha', body);
      // console.log(dataArray)
      CHART.chartPie('JenisUsaha', 'Jenis Usaha (Org/%)', dataArray)
    },


    dataPendidikan : async function(){
      var body = this.form
      var dataArray = await CHART.postData('Pendidikan', body);
      // console.log(dataArray)
      CHART.BarChart('dataPendidikan', 'Data Pendidikan', 'Data Potensi Wilayah', dataArray.uraian, dataArray.jumlah)
    },

    dataPekerjaan : async function(){
      var body = this.form
      var dataArray = await CHART.postData('Pekerjaan', body);
      // console.log(dataArray)
      CHART.chartPie('dataPekerjaan', 'Data Pekerjaan (Org/%)', dataArray)
    },

    dataAgama: async function(){
      var body = this.form
      var dataArray = await CHART.postData('Agama', body);
      // console.log(dataArray)
      CHART.chartPie3D('dataAgama', 'Agama (Org/%)', dataArray)
    },

    dataKeluarga : async function(){
      var body = this.form
      var dataArray = await CHART.postData('Keluarga', body);
      // console.log(dataArray)
      CHART.chartPie('dataKeluarga', 'Data Keluarga (Org/%)', dataArray)
    },

    PiramidaPenduduk : async function(){
      var body = this.form
      var dataArray = await CHART.postData('PiramidaPenduduk', body);
      // console.log(dataArray)
      CHART.BarChart('PiramidaPenduduk', 'Potensi  Piramida Penduduk', 'Usia/Org', dataArray.uraian, dataArray.jumlah)
    },

    StatusSosial: async function(){
      var body = this.form
      var dataArray = await CHART.postData('StatusSosial', body);
      // console.log(dataArray)
      CHART.chartPie3D('StatusSosial', 'Status Sosial (Org/%)', dataArray)
    },



    LayananPendidikan : async function(){
      var body = this.form
      var dataArray = await CHART.postData('LayananPendidikan', body);
      // console.log(dataArray)
      CHART.chartPie('LayananPendidikan', 'Data Fasilitas Pendidikan (Unit/%)', dataArray)
    },
    LayananPemerintahan : async function(){
      var body = this.form
      var dataArray = await CHART.postData('LayananPemerintahan', body);
      // console.log(dataArray)
      CHART.chartPie('LayananPemerintahan', 'Data Fasilitas Pemerintahan (Unit/%)', dataArray)
    },
    LayananKesehatan : async function(){
      var body = this.form
      var dataArray = await CHART.postData('LayananKesehatan', body);
      // console.log(dataArray)
      CHART.chartPie('LayananKesehatan', 'Data Fasilitas Kesehatan (Unit/%)', dataArray)
    },
    LayananUmum : async function(){
      var body = this.form
      var dataArray = await CHART.postData('LayananUmum', body);
      // console.log(dataArray)
      CHART.chartPie('LayananUmum', 'Data Fasilitas Umum (Unit/%)', dataArray)
    },
    LayananKeagamaan : async function(){
      var body = this.form
      var dataArray = await CHART.postData('LayananKeagamaan', body);
      // console.log(dataArray)
      CHART.chartPie('LayananKeagamaan', 'Data Fasilitas Keagamaan (Unit/%)', dataArray)
    },
    LayananPenunjang : async function(){
      var body = this.form
      var dataArray = await CHART.postData('LayananPenunjang', body);
      // console.log(dataArray)
      CHART.chartPie('LayananPenunjang', 'Data Fasilitas Penunjang (Org/%)', dataArray)
    },



    cari_data(){
      this.Potensi_Wilayah();
      this.JenisUsaha();
      this.dataPendidikan();
      this.dataPekerjaan();
      this.dataAgama();
      this.dataKeluarga();
      this.PiramidaPenduduk();
      this.StatusSosial();

      this.LayananPendidikan();
      this.LayananPemerintahan();
      this.LayananKesehatan();
      this.LayananUmum();
      this.LayananKeagamaan();
      this.LayananPenunjang();
    },




    

    async button(){
      await setTimeout(() => {
        console.log('ini query pembacaannya')
      }, 2000);
      // console.log('telASO')
    },

    pembulatan(n){
      return n.toFixed(2);
    },


    chageDesa(){
      this.form.des_kel = ''
      if (this.form.kecamatan == '' || this.form.kecamatan == undefined || this.form.kecamatan == null) {
        WILAYAH.postDesKelAutocomplete();
      } else {
        WILAYAH.postDesKelAutocomplete(this.form.kecamatan);
        
      }
    },


    filterSelect : function(profile){
      if (profile.aksesWilayah == 0) {
        WILAYAH.getListDesKelFull();
        this.form.des_kel = profile.des_kel
        this.disable_des = true
        this.disable_kec = true
      } else if (profile.aksesWilayah == 1) {
        this.form.kecamatan = profile.kecamatan
        WILAYAH.postDesKel(profile.kecamatan)
        this.disable_kec = true
        this.disable_des = false

      } else if (profile.aksesWilayah == 2) {
        WILAYAH.getListDesKelFull();
        this.disable_kec = false
        this.disable_des = false
      }
    },







  },

  mounted () {
    // this.getBarRelawan();
    // this.getBarDukungan();
    // this.getCabup();
    // this.getBar();
    // this.Potensi_Wilayah();
    // this.JenisUsaha();
    // this.button();
    this.form.tahun = UMUM.getTahun();
    WILAYAH.getListKecamatan();
    


    var profilex = JSON.parse(localStorage.profile)
    var profile = profilex.profile
    this.$store.state.ID_DES_KEL = profile.des_kel

    this.filterSelect(profile)

    
    this.cari_data();

    // console.log(this.$store.state.ID_DES_KEL)


  },
}
